import { useQuery } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import { RiSearchLine } from 'react-icons/ri'
import { Oval } from 'react-loader-spinner'
import { apiClient } from '../helpers/Axios'
import ReactPaginate from 'react-paginate'
import Wrapper from '../helpers/Wrapper'
import { useSearchParams } from 'react-router-dom'
import { MdOutlineReportGmailerrorred } from 'react-icons/md'
import Product from '../components/Product/Product'

function Search() {

    const [params, setParams] = useSearchParams()

    const [searchInput, setSearchInput] = useState(params?.get("query") || "")
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)


    const { data: dataOnFetch, isLoading } = useQuery({
        queryKey: ['s-s'],
        queryFn: async () => {
            const res = await apiClient.get('/search/search', { params: { query: searchInput } });
            return res.data
        },
        enabled: params?.get("query")?.length > 0
    })

    useEffect(() => { setData(dataOnFetch) }, [dataOnFetch])


    // when button clicked
    const btnClicked = async () => {
        if (searchInput?.length > 0) {
            setLoading(true)
            params.set("query", searchInput)
            setParams(params)
            try {
                const res = await apiClient.get('/search/search', { params: { query: searchInput } });
                if (res?.data) {
                    setData(res.data)
                    setLoading(false)
                    return
                }
            } catch (error) {
                console.log(error);
                setLoading(false)
            }
        }
        return
    }

    // when paginate changed

    const pageNumberChange = async ({ selected }) => {
        setLoading(true)
        params.set("query", searchInput)
        params.set("page", selected + 1)
        setParams(params)
        try {
            const res = await apiClient.get('/search/search', { params: { query: searchInput, page: selected + 1 } });
            if (res?.data) {
                setData(res.data)
                setLoading(false)
                return
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    return (
        <div className='w-full relative mt-14'>
            <Wrapper>


                {/* Input search */}
                <div className="w-full py-3">
                    <div className="mx-auto max-w-3xl">
                        {data?.data ?
                            <h1 className="text-center text-xl sm:text-[clamp(1.3rem,2vw+1rem,1.8rem)] font-medium">
                                Found results {data?.data?.length} for "{params.get("query")}"
                            </h1> :

                            <h1 className="text-center text-xl sm:text-[clamp(1.3rem,2vw+1rem,1.8rem)] font-medium">
                                Search Our Site
                            </h1>
                        }

                        <div className="mt-5 relative">
                            <input
                                onChange={(e) => setSearchInput(e.target.value)}
                                value={searchInput}
                                type="text"
                                placeholder="I'm looking for..."
                                className="w-full outline-none rounded-full py-3.5 border focus:border-black px-7"
                            />
                            {(isLoading || loading) && (
                                <div className="absolute top-1/2 -translate-y-1/2 right-14">
                                    <Oval width={16} height={16} strokeWidth={5} />
                                </div>
                            )}
                            <div className="absolute top-1/2 -translate-y-1/2 right-6">
                                <button onClick={btnClicked}>
                                    <RiSearchLine size={20} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                {data?.data && data?.data?.length > 0 ? (
                    <div className="mt-8 grid grid-cols-2 gap-5 mx-auto max-w-7xl md:grid-cols-3 xl:grid-cols-4">
                        {data?.data?.map((product, i) => (
                            <Product data={product} key={i} loading={loading} />
                        ))}
                    </div>
                ) : (data?.data?.length > 0 && searchInput?.length > 0) &&
                <div className="mt-8">
                    <div className="bg-[#faf0de] p-5 max-w-64 text-yellow-700 border border-yellow-500 rounded-lg">
                        <MdOutlineReportGmailerrorred />
                        <p className="text-[clamp(1rem,2vw+0.9rem,1.1rem]">
                            No products found
                        </p>
                    </div>
                </div>
                }


                {data?.data?.length > 0 && (
                    <div className="mt-8 flex w-full justify-center">
                        <ReactPaginate
                            previousLabel={false}
                            nextLabel={false}
                            breakLabel="..."
                            pageCount={Number(data?.totalPages)}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={1}
                            onPageChange={pageNumberChange}
                            containerClassName={'flex items-center gap-3 mx-5 relative justify-center'}
                            pageClassName={`border size-12 flex items-center justify-center rounded-full hover:border-black transition`}
                            activeClassName={'border-black'}
                            previousLinkClassName={'previous-link'}
                            nextLinkClassName={'next-link'}
                        />

                    </div>
                )}
            </Wrapper>
        </div>
    )
}

export default Search